import { render, staticRenderFns } from "./ChartComponentS2.vue?vue&type=template&id=138482ca&scoped=true&"
import script from "./ChartComponentS2.vue?vue&type=script&lang=js&"
export * from "./ChartComponentS2.vue?vue&type=script&lang=js&"
import style0 from "./ChartComponentS2.vue?vue&type=style&index=0&id=138482ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138482ca",
  null
  
)

export default component.exports